import { Brain, CheckCircle2, Cloud, Globe, Server } from 'lucide-react';
import React from 'react';


const TechStackSection = ({
  title,
  subtitle,
}) => {

  const techCategories = [
    {
      title: "Frontend",
      icon: <Globe className="w-6 h-6" />,
      color: "from-blue-500 to-cyan-600",
      techs: [
        { name: "React/Next.js", desc: "Lightning-fast interfaces" },
        { name: "TypeScript", desc: "Type-safe code" },
        { name: "Tailwind CSS", desc: "Modern styling" },
        { name: "Flutter", desc: "Cross-platform mobile" }
      ]
    },
    {
      title: "Backend",
      icon: <Server className="w-6 h-6" />,
      color: "from-purple-500 to-pink-600",
      techs: [
        { name: "Node.js/Python", desc: "Scalable APIs" },
        { name: "PostgreSQL", desc: "Reliable data storage" },
        { name: "Redis", desc: "High-speed caching" },
        { name: "GraphQL", desc: "Efficient data fetching" }
      ]
    },
    {
      title: "Cloud & DevOps",
      icon: <Cloud className="w-6 h-6" />,
      color: "from-green-500 to-emerald-600",
      techs: [
        { name: "AWS/Azure", desc: "Enterprise cloud" },
        { name: "Docker/K8s", desc: "Container orchestration" },
        { name: "CI/CD", desc: "Automated deployments" },
        { name: "Monitoring", desc: "24/7 system health" }
      ]
    },
    {
      title: "AI & Analytics",
      icon: <Brain className="w-6 h-6" />,
      color: "from-orange-500 to-red-600",
      techs: [
        { name: "OpenAI/Claude", desc: "AI integrations" },
        { name: "TensorFlow", desc: "Machine learning" },
        { name: "Analytics", desc: "User insights" },
        { name: "A/B Testing", desc: "Data-driven optimization" }
      ]
    }
  ];


  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-600 text-sm font-medium mb-4">
          Modern Tech Stack
          </span>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-gray-900">{title}</h2>
          <p className="md:text-lg text-gray-600">{subtitle}</p>
        </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
                {techCategories.map((category, index) => (
                  <div key={index} className="group">
                    <div className="bg-gradient-to-b from-slate-900 to-slate-950 rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all hover:bg-white/10">
                      <div className={`w-12 h-12 rounded-xl bg-gradient-to-r ${category.color} text-white flex items-center justify-center mb-4 shadow-lg`}>
                        {category.icon}
                      </div>
                      <h3 className="text-xl text-white font-bold mb-4">{category.title}</h3>
                      <div className="space-y-3">
                        {category.techs.map((tech, i) => (
                          <div key={i} className="flex items-start gap-3">
                            <CheckCircle2 className="w-5 h-5 text-green-400 mt-0.5 shrink-0" />
                            <div>
                              <div className="font-semibold text-white">{tech.name}</div>
                              <div className="text-sm text-gray-400">{tech.desc}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
      </div>
    </section>
  );
};

export default TechStackSection;